import React from 'react';
import styles from "../myprofile/myprofile.module.css";
import ProfileMenu from '../../Components/profilemenu/ProfileMenu';
import DashCards from '../../Components/DashCards';
import AllOrderTab from '../../Components/orderscomp/AllOrderTab';

const AllOrders = () => {
    return (
        <div className={styles.myprofile}>
            <div className={styles.promenu}>
                <ProfileMenu />
            </div>
            <div style={{ display: 'flex', gap: '24px', flexDirection: "column", flex: 1, minWidth: 0 }}>
                <DashCards type="orders" />
                <div style={{ display: 'flex', gap: '24px', width: '100%' }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                        <AllOrderTab />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AllOrders;